export const SEND_REVIEW = 'send_review'
